import React from 'react';
import { Field } from 'react-final-form';
import { FormControlLabel, Checkbox } from '@mui/material';

const CheckboxField = ({ name, label, labelPlacement = 'end', variant = 'standard', ...rest }) => (
  <Field
    name={name}
    type="checkbox"
    render={({ input }) => (
      <FormControlLabel
        label={label}
        labelPlacement={labelPlacement}
        variant={variant}
        control={<Checkbox {...input} {...rest} />}
      />
    )}
  />
);

export default CheckboxField;
